import React from 'react';
import styled from 'styled-components';
import img from '../resources/main.jpg'

const Content = styled('div')`
    align-items: center;     
    display: flex;
    justify-content: center;
     
    img {
        height: 40%;
        width: 40%;
    }
`;

class Home extends React.Component {
    render() {
        return (
            <Content>
                <img alt='digital activation' src={img} />
            </Content>
        );
    }
}

export default Home;